import { Sounds } from '.';
import { AssetBundle, AssetBundleState } from '../../platform/assets/AssetBundle';

export class LocalSoundBundle implements AssetBundle {
    state: AssetBundleState;

    public load(): Promise<void> {
        this.state = 'loading';

        for (const path of Object.values(Sounds)) {
            const elmt = document.createElement('audio');
            elmt.src = path;
            elmt.preload = 'auto';
            document.body.appendChild(elmt);
        }

        this.state = 'ready';
        return Promise.resolve();
    }

}
